@if (visible$ | async) {
  <app-chart-tile
    [title]="'differential-pressure-chart.title' | translate"
    [getSeries]="getSeries"
    [options]="options"
    [userTrackingPeriodOptions]="userTrackingPeriodOptions"
    >
  </app-chart-tile>
}
